import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

@Injectable()
export class CustomOverlayContainer extends OverlayContainer {

  private findHostElement(): HTMLElement | null {
    // 🔍 1. Buscar directo en el DOM
    let host = document.querySelector('belender-web-component') as HTMLElement | null;
    if (host) return host;

    // 🔍 2. Buscar recursivamente en todos los shadowRoots
    const deepSearch = (node: Node): HTMLElement | null => {
      if ((node as HTMLElement).shadowRoot) {
        const shadow = (node as HTMLElement).shadowRoot!;
        const found = shadow.querySelector('belender-web-component') as HTMLElement | null;
        if (found) return found;

        // recursion: buscar dentro de los hijos del shadowRoot
        for (const child of Array.from(shadow.children)) {
          const nested = deepSearch(child);
          if (nested) return nested;
        }
      }

      // seguir buscando en el DOM normal
      for (const child of Array.from(node.childNodes)) {
        const nested = deepSearch(child);
        if (nested) return nested;
      }

      return null;
    };

    return deepSearch(document.documentElement);
  }

  protected _createContainer(): void {
    // Crear el contenedor
    const container = document.createElement('div');
    container.classList.add('cdk-overlay-container');

    // Buscar host dinámicamente
    const hostElement = this.findHostElement();

    if (hostElement) {
      // si tiene shadowRoot => lo ponemos ahí
      if (hostElement.shadowRoot) {
        hostElement.shadowRoot.appendChild(container);
        console.log('✅ Overlay inyectado en shadowRoot del WebComponent');
      } else {
        hostElement.appendChild(container);
        console.log('✅ Overlay inyectado dentro del WebComponent');
      }
    } else {
      // fallback SPA
      document.body.appendChild(container);
      console.log('⚠️ No se encontró <belender-web-component>, usando <body>');
    }

    this._containerElement = container;
  }
}
